export class UserDataModel {
    stepIndex: number;
    customerData: KeyValuePair[];
    selectedDate: Date;
    selectedAreaId?: string;
    selectedGroupId?: string;
}

export class KeyValuePair {
    constructor(
        public key: string,
        public value: Object) { }
}
